<div class="container-landing">
  <app-navbar></app-navbar>

  <!-- map section-->
  <div class="overlay">
    <div class="overlay-left">
      <div class="bold-text">
        <h2>Modern payment solutions for Nigeria & Africa</h2>
      </div>
      <div class="parag" data-aos="fade-up" data-aos-duration="1000">
        <p>
          A flexible payment solution that support every stage of your growth
        </p>
      </div>
      <div class="btn-holder">
        <!-- <div class="btn">
          <button class="btn-agent" (click)="navigateUrl('/become-agent')">
            Become POS Agent
          </button>
        </div> -->
        <!-- <div class="btn">


          <button
            class="btn-agent-setup"
            (click)="navigateUrl('/become-merchant')"
          >

          Become POS Merchant
          </button>
        </div> -->

        <div class="btn">
          <button class="btn-agent" (click)="openAgentModal()">
            Become POS Merchant
          </button>
        </div>
        <!-- <div class="btn">
          <button class="btn-agent-setup" (click)="openDevDocs()">
            Developer Docs
          </button>
        </div> -->
      </div>
    </div>
  </div>
  <!--End  map section-->

  <app-business-model-section></app-business-model-section>

  <!-- seamless payment section-->
  <div class="seamless-section">
    <div class="seamless-title">
      <button class="btn-seamless" data-aos="fade-up" >seamless Payment Experience</button>
    </div>
    <div class="seamless-heading">
      <h2>Make payment the best part of transacting with you!</h2>
    </div>
    <div class="seamless-payment">
      <div class="left" data-aos="fade-up-right" data-aos-duration="3000">
        <div class="icon">
          <img src="../../../../assets/img/icon1.png" alt="" />
        </div>
        <div class="text">
          <div class="text-title">
            <h3>Secure Transactions</h3>
          </div>
          <div class="text-msg">
            <h4>
              We provide cutting-edge innovative infrastructure aimed at
              creating infinite possibilities of secure transactions.
            </h4>
          </div>
        </div>
      </div>
      <div class="middle" data-aos="fade-up-right" data-aos-duration="2000">
        <div class="icon">
          <img src="../../../../assets/img/icon2.png" alt="" />
        </div>
        <div class="text">
          <div class="text-title">
            <h3>Reporting</h3>
          </div>
          <div class="text-msg">
            <h4>
              HuiosPay simplify your bookkeeping processes and help maximize
              your output for efficiency to help reach your zenith.
            </h4>
          </div>
        </div>
      </div>
      <div class="right" data-aos="fade-up-right" data-aos-duration="1000">
        <div class="icon">
          <img src="../../../../assets/img/icon3.png" alt="" />
        </div>
        <div class="text">
          <div class="text-title">
            <h3>99.9% Success Rates</h3>
          </div>
          <div class="text-msg">
            <h4>
              Enjoy streamlined and seamless transaction experience with highly
              competitive and phenomenal success rate on HuiosPay.
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End seamless payment section-->

  <!-- what we do-->
  <div class="what-we-do">
    <div class="wwd-left" data-aos="fade-up-right" data-aos-duration="2000">
      <img src="../../../../assets/img/terminal1.png" alt="terminal" />
    </div>
    <div class="wwd-right" data-aos="fade-up-left" data-aos-duration="2000">
      <div class="wwd-button">
        <button class="btn-wwd">What We Do?</button>
      </div>
      <div class="wwd-title">
        <h2>Accept payments from multiple channels.</h2>
      </div>
      <div class="wwd-text">
        <h3>
          Our goal is to expose your business to an endless possibilities of
          modern, frictionless and painless payments. Our ongoing commitment to
          efficiency manifests in our ability to provide a wide variety of
          payment options for your business needs.
        </h3>
      </div>
      <div class="wwd-bulletin">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Debit/Credit Cards</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>POS</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Mobile Money</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>USSD</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Bank Transfer</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Visa QR</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end of what we do-->

  <!-- why us section -->
  <div class="why-us">
    <div class="wu-left" data-aos="fade-up-right" data-aos-duration="2000">
      <div class="wu-btn">
        <button class="btn-wwd">Why Us ?</button>
      </div>
      <div class="wu-title">
        <h3>Find out why we are the preferred payment platform in Africa!</h3>
      </div>
      <div class="wu-card">
        <div class="icon">
          <img src="../../../../assets/img/why1.png" alt="why-us" />
        </div>
        <div class="right">
          <div class="title">
            <h3>Security</h3>
          </div>
          <div class="text">
            <h4>
              Our platform is designed to provide end-to-end protection against
              fraud and suspicious activities.
            </h4>
          </div>
        </div>
      </div>
      <div class="wu-card">
        <div class="icon">
          <img src="../../../../assets/img/why2.png" alt="why-us" />
        </div>
        <div class="right">
          <div class="title">
            <h3>Fast Settlement</h3>
          </div>
          <div class="text">
            <h4>
              We ensure the fastest remittance window to your approved account
              within 24 hours.
            </h4>
          </div>
        </div>
      </div>
      <div class="wu-card">
        <div class="icon">
          <img src="../../../../assets/img/why3.png" alt="why-us" />
        </div>
        <div class="right">
          <div class="title">
            <h3>Dispute Resolution</h3>
          </div>
          <div class="text">
            <h4>
              Claims and disputes are resolved within the shortest possible time.
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="wu-right" data-aos="fade-up-left" data-aos-duration="2000">
      <img src="../../../../assets/img/why.png" alt="why us" />
    </div>
  </div>
  <!-- End of Why us Section -->

  <!-- Get on Huiospay safe train-->
  <div class="huiospay-safe-tain">
    <div class="hst-left" data-aos="fade-up-right" data-aos-duration="2000">
      <img src="../../../../assets/img/huiospay-train.png" alt="terminal" />
    </div>
    <div class="hst-right" data-aos="fade-up-left" data-aos-duration="2000">
      <div class="hst-button">
        <button class="btn-hst">GET ON HUIOSPAY SAFE TRAIN</button>
        <button class="btn-hst-two">HUIOSPAY SAFE TRAIN</button>
      </div>
      <div class="hst-title">
        <h2>Integrating HuiosPay APIs and start Collecting</h2>
      </div>
      <div class="hst-text">
        <h3>
          Our API's has been developed with Developers in mind; well-documented
          API's that let you build every features within the shortest period
          of time. If you can imagine it, you can build it with HuiosPay.
        </h3>
      </div>
      <div class="hst-bulleton">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>
                Collect one-time and recurring payments from your app or
                website.
              </p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Make instant transfers</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Retrieve all your transactions and customer data</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Verify the identity of customers</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="coming-soon">
        <h4>
          <a href="https://huiospay-payment-gateway.netlify.app/">
            Payment Gateway</a
          >
        </h4>
        <img src="../../../../assets/img/arrow.png" alt="icon" />
      </div> -->
    </div>
  </div>
  <!-- End Get on Huiospay safe train-->

  <!-- Community section-->
  <app-community-section></app-community-section>
  <!--End Community section-->

  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->
</div>

<app-back-to-top
  [acceleration]="2"
  [animate]="true"
  [scrollDistance]="50"
  [speed]="50"
>
</app-back-to-top>

<app-pos-merchant-modal [isOpen]="showAgentModal" (closed)="showAgentModal = false"></app-pos-merchant-modal>
